module.exports = __webpack_public_path__ + "5c27126dc5d527281447e30cdab0337c.pdf";